import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Intervento } from '../../../models/intervento.model';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { Richiesta } from '../../../models/richiesta.model';
import { StiliService } from '../../../services/stili.service';
import { InterventiService } from '../../../services/interventi.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-riproponi-intervento',
  templateUrl: './riproponi-intervento.component.html',
  styleUrls: ['./riproponi-intervento.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    ReactiveFormsModule,
    InputNumberModule,
    ToastModule
  ],
  providers: [MessageService]
})
export class RiproponiInterventoComponent {
  @Input() intervento: Intervento = {} as Intervento;
  @Input() richiesta: Richiesta = {} as Richiesta;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() conferma = new EventEmitter<Intervento>();

  header = 'Riproponi Intervento';
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public stiliService: StiliService,
    private interventiService: InterventiService,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      importoRichiesto: [null, [Validators.required, Validators.min(0)]]
    });
  }

  show() {
    this.visible = true;
    this.form.reset();
    if (this.intervento?.importoRichiesto) {
      this.form.patchValue({
        importoRichiesto: this.intervento.importoRichiesto
      });
    }
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.reset();
  }

  reset() {
    this.form.reset();
    this.intervento = {} as Intervento;
  }

  onHide() {
    this.hide();
  }

  onConferma() {
    if (this.form.valid) {
      this.intervento.importoRichiesto = this.form.get('importoRichiesto')?.value;
      this.interventiService.riproponi(this.intervento).subscribe({
        next: (intervento) => {
          this.conferma.emit(intervento);
          this.hide();
          this.reset();
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Si è verificato un errore durante la riproposizione dell\'intervento',
            life: 3000
          });
          this.hide();
          this.reset();
        }
      });

    /*   const interventoClonato = { ...this.intervento };
      if (!interventoClonato.richiesta) {
        interventoClonato.richiesta = { ...this.intervento.richiesta } as Richiesta;
      }
      if (interventoClonato.richiesta) {
        interventoClonato.richiesta.importoRichiesto = this.form.get('importoRichiesto')?.value;
        this.conferma.emit(interventoClonato);
        this.hide();
      } */
    }
  }
}
